import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
});



/* ----------------------------------
  　慣性スクロール
---------------------------------- */

const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});




/* ----------------------------------
  スムーススクロール
---------------------------------- */
$(function () {
  function getHeaderHeight(isPageLoad) {
    // ページ読み込み時（#がある場合）とそれ以外でヘッダー高さを変更
    if (isPageLoad) {
      // ページ読み込み時（#がある場合）は、異なる高さを設定
      return window.innerWidth <= 768 ? 70 : 110;  // スマホの場合の高さ調整
    } else {
      // それ以外の場合（クリック時）は通常のヘッダー高さ
      return window.innerWidth <= 768 ? 70 : $('.is_fixed').outerHeight() || 150;
    }
    
  }

  // ページ内リンクをクリックしたとき：アニメーション付き
  $('a[href*="#"]').click(function () {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      const hash = this.hash;
      const $target = $(hash);
      if ($target.length) {
        const position = $target.offset().top - getHeaderHeight(false);
        $("html, body").animate({ scrollTop: position }, 600, "swing");
        return false;
      }
    }
  });

  // ページ読み込み時：アニメーションなしで即移動
  if (location.hash) {
    const $target = $(location.hash);
    if ($target.length) {
      const position = $target.offset().top - getHeaderHeight(true);
      $(window).scrollTop(position); // ← アニメーションなしで即スクロール
    }
  }
});


/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  let navEle = document.querySelector('.hd_menu-toggle');
  let navWrap = document.querySelector('.hd_nav');

  // メニューボタン（.hd_menu-toggle）をクリックした時の動作
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    navWrap.classList.toggle('is_open', !isOpen);
    navEle.classList.toggle('is_open', !isOpen);
  });
});



/* ----------------------------------
　HOME　商品紹介　下から上にフェードイン
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".product-category-block");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // indexを取得して、ちょっとずつ遅延
        const index = Array.from(blocks).indexOf(entry.target);
        entry.target.style.transitionDelay = `${index * 0.15}s`;
        entry.target.classList.add("is-show");
        observer.unobserve(entry.target); // 一度だけ実行
      }
    });
  }, { threshold: 0.2 });

  blocks.forEach((block) => observer.observe(block));
});


/* ----------------------------------
　MVアニメーション
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const mainttl = document.querySelector('.index_mv-mainttl');
  const subttl = document.querySelector('.index_mv-subttl');
  const images = [
    document.querySelector('.mainimg01'),
    document.querySelector('.mainimg02'),
    document.querySelector('.mainimg03'),
    document.querySelector('.mainimg04')
  ];
 if (!mainttl || !subttl || images.some(img => !img)) return; // ← ここ追加
  // --- サブタイトルを1文字ずつ分割 ---
  const text = subttl.textContent.trim();
  subttl.textContent = '';
  text.split('').forEach((char, i) => {
    const span = document.createElement('span');
    span.textContent = char;
    span.style.animationDelay = `${i * 0.1}s`;
    subttl.appendChild(span);
  });

  // --- 1. メインタイトル表示 ---
  setTimeout(() => {
    mainttl.classList.add('is-show');
  }, 500);

  // --- 2.サブタイトル（1文字ずつ）＋ 画像表示 ---
  setTimeout(() => {
    subttl.style.opacity = 1; // subttl自体を表示

    const spans = subttl.querySelectorAll('span');
    spans.forEach((span) => {
      span.classList.add('is-show');
    });

    // 画像を順番に表示
    images.forEach((img, index) => {
      setTimeout(() => {
        img.classList.add('is-show');
      }, index * 400);
    });
  }, 1000); // メインタイトル後に発動
});



/* ----------------------------------
　画像アニメーション
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const flowers = document.querySelectorAll('.animate-flower');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        observer.unobserve(entry.target); // 一度だけ発火したい場合
      }
    });
  }, {
    threshold: 0.2 // 要素が20%見えたら発火
  });

  flowers.forEach(flower => observer.observe(flower));
});




document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('load', () => {
    const lowMv = document.querySelector('.low_mv-ttl');
    if (!lowMv) return;

    // ① low_mv-ttl自体をフェードイン
    lowMv.style.opacity = 1;

    // ② 文字を一文字ずつ span に分解
    const text = lowMv.textContent.trim();
    lowMv.textContent = '';

    text.split('').forEach((char, i) => {
      const span = document.createElement('span');
      span.textContent = char;
      lowMv.appendChild(span);

      // 文字ごとに順番に is-show クラスを付与
      setTimeout(() => {
        span.classList.add('is-show');
      }, i * 50); // i*50msごとに遅延
    });
  });
});




/* ----------------------------------
　カテゴリボタンのカレント
---------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
  const sidebarLinks = document.querySelectorAll('.cmn_sidebar_category a');

  // セクションごとの配列
  const sections = Array.from(sidebarLinks).map(link => {
    const targetId = link.getAttribute('href').replace('#', '');
    const targetEl = document.getElementById(targetId);
    return { link: link.parentElement, section: targetEl };
  });

  function updateActive() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    let currentActive = null;

    sections.forEach(s => {
      if (!s.section) return;
      const top = s.section.offsetTop;
      const bottom = top + s.section.offsetHeight;

      // セクションの中央あたりが画面に入ったら
      if (scrollY + windowHeight / 2 >= top && scrollY + windowHeight / 2 < bottom) {
        currentActive = s.link;
      }
    });

    // 一旦全部から active を削除
    sections.forEach(s => s.link.classList.remove('active'));

    // 現在のセクションだけ active を付与
    if (currentActive) currentActive.classList.add('active');
  }

  // 初回判定
  updateActive();

  // スクロール時に判定
  window.addEventListener('scroll', updateActive);
  window.addEventListener('resize', updateActive);
});
